import { z } from 'zod';
import { ORIGENES_DE_DATO, PATRON_FECHA_PARCIAL } from '../catalogos/nucleo.js';
import { esquemaId } from './comunes.js';
/**
 * Problemas y diagnosticos (F2.1, plan maestro §5.4).
 *
 * Texto obligatorio, codigo OPCIONAL: no se fuerza un codigo incorrecto para
 * poder guardar. Si hay codigo, dice de que catalogo y version viene. El estado
 * clinico y la certeza son ejes distintos: un problema puede estar activo y ser
 * provisional.
 */
export const SISTEMAS_DE_CODIGO = ['CIE-10', 'CIE-11', 'SNOMED-CT', 'local'];
export const ESTADOS_CLINICOS_DE_PROBLEMA = [
    'activo',
    'recurrente',
    'en-remision',
    'inactivo',
    'resuelto',
];
export const CERTEZAS_DE_PROBLEMA = [
    'provisional',
    'diferencial',
    'confirmado',
    'descartado',
    'registrado-por-error',
];
export const esquemaCodigoClinico = z
    .object({
    sistema: z.enum(SISTEMAS_DE_CODIGO),
    version: z.string().trim().max(40).default(''),
    codigo: z.string().trim().min(1).max(40),
    texto: z.string().trim().max(300).default(''),
})
    .strict();
const esquemaFechaParcial = z
    .string()
    .trim()
    .regex(PATRON_FECHA_PARCIAL, 'Use AAAA, AAAA-MM o AAAA-MM-DD');
export const esquemaRegistrarProblema = z
    .object({
    pacienteId: esquemaId,
    encuentroId: esquemaId.optional(),
    descripcion: z.string().trim().min(2, 'Describa el problema').max(500),
    codigo: esquemaCodigoClinico.optional(),
    estadoClinico: z.enum(ESTADOS_CLINICOS_DE_PROBLEMA).default('activo'),
    certeza: z.enum(CERTEZAS_DE_PROBLEMA).default('confirmado'),
    inicio: esquemaFechaParcial.optional(),
    resolucion: esquemaFechaParcial.optional(),
    origen: z.enum(ORIGENES_DE_DATO).default('profesional'),
    nota: z.string().trim().max(1000).default(''),
})
    .strict()
    .refine((p) => p.estadoClinico === 'resuelto' || p.resolucion === undefined, {
    message: 'Solo un problema resuelto tiene fecha de resolución',
    path: ['resolucion'],
});
export const esquemaActualizarProblema = z
    .object({
    versionEsperada: z.number().int().min(0),
    estadoClinico: z.enum(ESTADOS_CLINICOS_DE_PROBLEMA).optional(),
    certeza: z.enum(CERTEZAS_DE_PROBLEMA).optional(),
    codigo: esquemaCodigoClinico.optional(),
    resolucion: esquemaFechaParcial.optional(),
    nota: z.string().trim().max(1000).optional(),
})
    .strict();
/** Listar lo longitudinal de una paciente: problemas, alergias o medicacion. */
export const esquemaListarDePaciente = z.object({ pacienteId: esquemaId });
//# sourceMappingURL=problema.js.map